import React from 'react';
import styles from './ErrorBoundary.module.scss';
import { Button } from 'antd';
import warningIcon from '@/assets/icons/warningIcon.webp';
import { useRouteError } from 'react-router';
import Navbar from '@/components/navbar/Navbar';

const ErrorBoundary = () => {
  const error = useRouteError();

  const handleRefresh = () => {
    window.location.reload();
  };

  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserName = '未知浏览器';
    let browserVersion = '未知版本';
    let systemName = '未知系统';
    let systemVersion = '未知版本';

    // 获取浏览器信息
    if (userAgent.indexOf('Firefox') > -1) {
      browserName = 'Firefox';
      browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)[1];
    } else if (userAgent.indexOf('SamsungBrowser') > -1) {
      browserName = 'Samsung Browser';
      browserVersion = userAgent.match(/SamsungBrowser\/([0-9.]+)/)[1];
    } else if (
      userAgent.indexOf('Opera') > -1 ||
      userAgent.indexOf('OPR') > -1
    ) {
      browserName = 'Opera';
      browserVersion = userAgent.match(/(?:Opera|OPR)\/([0-9.]+)/)[1];
    } else if (userAgent.indexOf('Trident') > -1) {
      browserName = 'Internet Explorer';
      browserVersion = userAgent.match(/rv:([0-9.]+)/)[1];
    } else if (userAgent.indexOf('Edge') > -1) {
      browserName = 'Edge';
      browserVersion = userAgent.match(/Edge\/([0-9.]+)/)[1];
    } else if (userAgent.indexOf('Chrome') > -1) {
      browserName = 'Chrome';
      browserVersion = userAgent.match(/Chrome\/([0-9.]+)/)[1];
    } else if (userAgent.indexOf('Safari') > -1) {
      browserName = 'Safari';
      browserVersion = userAgent.match(/Version\/([0-9.]+)/)[1];
    }

    // 获取系统信息
    if (userAgent.indexOf('Windows') > -1) {
      systemName = 'Windows';
      // 获取Windows版本
      if (userAgent.indexOf('Windows NT 10.0') > -1) {
        systemVersion = '10';
      } else if (userAgent.indexOf('Windows NT 6.3') > -1) {
        systemVersion = '8.1';
      } else if (userAgent.indexOf('Windows NT 6.2') > -1) {
        systemVersion = '8';
      } else if (userAgent.indexOf('Windows NT 6.1') > -1) {
        systemVersion = '7';
      } else if (userAgent.indexOf('Windows NT 6.0') > -1) {
        systemVersion = 'Vista';
      } else if (userAgent.indexOf('Windows NT 5.1') > -1) {
        systemVersion = 'XP';
      }
    } else if (userAgent.indexOf('Mac') > -1) {
      systemName = 'Mac OS';
      // 获取Mac OS版本
      const match = userAgent.match(/Mac OS X ([0-9_]+)/);
      if (match) {
        systemVersion = match[1].replace(/_/g, '.');
      }
    } else if (userAgent.indexOf('Linux') > -1) {
      systemName = 'Linux';
      // Linux通常无法通过userAgent获取具体版本
      systemVersion = '未知';
    } else if (userAgent.indexOf('Android') > -1) {
      systemName = 'Android';
      const match = userAgent.match(/Android ([0-9.]+)/);
      if (match) {
        systemVersion = match[1];
      }
    } else if (userAgent.indexOf('iOS') > -1) {
      systemName = 'iOS';
      const match = userAgent.match(/OS ([0-9_]+)/);
      if (match) {
        systemVersion = match[1].replace(/_/g, '.');
      }
    }

    return {
      browserName,
      browserVersion,
      systemName,
      systemVersion,
    };
  };

  const { browserName, browserVersion, systemName, systemVersion } =
    getBrowserInfo();

  return (
    <>
      <Navbar />
      <div className={styles.errorOverlay}>
        <div className={styles.errorContainer}>
          <img src={warningIcon} alt="" />
          <p className={styles.errorTitle}>页面错误</p>
          <p className={styles.errorSubtitle}>
            您可点击刷新,尝试让它工作找回页面
          </p>
          <Button
            type="primary"
            className={styles.refreshButton}
            onClick={handleRefresh}
          >
            刷新
          </Button>
          <p className={styles.errorContent}>
            <span className={styles.errorLabel}>错误信息:</span>{' '}
            无法显示此页面。错误代码: 00000
          </p>
          <p className={styles.errorMessage}>
            <span className={styles.infoItem}>Browser Name: {browserName}</span>
            <span className={styles.infoItem}>
              Browser Version: {browserVersion}
            </span>
            <span className={styles.infoItem}>System Name: {systemName}</span>
            <span className={styles.infoItem}>
              System Version: {systemVersion}
            </span>
          </p>
          {/* 具体组件报错 */}
          <div>
            {error && error.toString()}
            <br />
            {/* {errorInfo?.componentStack} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorBoundary;
